export enum RefillType {
  Individual = 'individual',
  LegalEntity = 'legal_entity',
}
